// src/Components/Sidebar/SubSidebarItem.tsx
import styled from 'styled-components';
import { COLORS } from '../../Styles/Colors';

const SubSidebarItem = styled.div<{ active?: boolean; $nested?: boolean }>`
  padding: ${props => (props.$nested ? '10px 16px' : '12px 16px')};
  padding-left: ${props => (props.$nested ? '36px' : '16px')};
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 8px;
  color: white;
  background-color: ${props => (props.active ? COLORS.teal : 'transparent')};
  transition:
    background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.2s ease;

  &:hover {
    background-color: ${props => (props.active ? COLORS.teal : `${COLORS.teal}cc`)};
    transform: translateX(3px);
  }

  &:active {
    transform: translateX(1px);
  }

  /* Fixed-width container for icons */
  & > *:first-child {
    width: ${props => (props.$nested ? '20px' : '22px')};
    height: ${props => (props.$nested ? '20px' : '22px')};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  & svg {
    width: ${props => (props.$nested ? '20px' : '22px')};
    height: ${props => (props.$nested ? '20px' : '22px')};
    fill: white;
  }

  /* Lucide icons are stroke-based; keep them outlined (not solid) */
  & svg.lucide {
    fill: none;
    stroke: white;
  }

  /* Target the text span specifically */
  & > span:last-child {
    flex: 1;
    min-width: 0;
    font-size: ${props => (props.$nested ? '14px' : '15px')};
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export default SubSidebarItem;